// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import TreeView from "@material-ui/lab/TreeView";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import ChevronRightIcon from "@material-ui/icons/ChevronRight";
// import TreeItem from "@material-ui/lab/TreeItem";

// const data = {
//   id: "root",
//   name: "Parent",
//   children: [
//     {
//       id: "1",
//       name: "Child - 1",
//     },
//     {
//       id: "3",
//       name: "Child - 3",
//       children: [
//         {
//           id: "4",
//           name: "Child - 4",
//         },
//       ],
//     },
//   ],
// };

// const useStyles = makeStyles({
//   root: {
//     height: 110,
//     flexGrow: 1,
//     maxWidth: 400,
//   },
// });

// const TreeViewStyle = () => {
//   const classes = useStyles();

//   const renderTree = (nodes) => (
//     <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
//       {Array.isArray(nodes.children)
//         ? nodes.children.map((node) => renderTree(node))
//         : null}
//     </TreeItem>
//   );
//   return (
//     <TreeView
//       className={classes.root}
//       defaultCollapseIcon={<ExpandMoreIcon />}
//       defaultExpanded={["root"]}
//       defaultExpandIcon={<ChevronRightIcon />}
//     >
//       {renderTree(data)}
//     </TreeView>
//   );
// };

// export default TreeViewStyle;

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ChevronRight from "@material-ui/icons/ChevronRight";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Favorite from "@material-ui/icons/Favorite";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import InfoIcon from "@material-ui/icons/Info";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import grey from "@material-ui/core/colors/grey";
import Item from "./Item";
import { red } from "@material-ui/core/colors";

const l_grey = grey[300];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    // padding: `0px ${theme.spacing(3)}px`,
    padding: 0,
  },
  listItem: {
    padding: 0,
  },
  listItemText: {
    flex: "0 1 auto",
    marginRight: "7px",
  },
  body1: {
    fontWeight: "bold",
  },
  listIcon: {
    minWidth: "unset",
    color: "black",
  },
  // arrow: {
  //   color: theme.palette.common.white,
  // },
  // tooltip: {
  //   backgroundColor: theme.palette.common.white,
  // },
  customWidth: {
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 1px 10px black",
    // border: "0.1px solid black",
    maxWidth: 160,
    fontSize: 12,

    // border: "0.5px solid black",
    // color: "black",
  },
  // bulletIcon: {
  //   fontSize: "10px",
  //   marginRight: "5px",
  // },
}));

// function BootstrapTooltip(props) {
//   const classes = useStyles();

//   return <Tooltip arrow classes={classes} {...props} />;
// }

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

// const ShowBrackets = ({ data, length }) => {
//   const text = length > 1 ? "items" : "item";
//   const brackets = Array.isArray(data) ? " [...]" : " {...}";
//   return (
//     <Typography component="span" variant="body2" color="textSecondary">
//       {`${brackets} // ${length} ${text}`}
//     </Typography>
//   );
// };

export default function Tree({
  data,
  length,
  parentName,
  isfirst,
  filter,
  totalparent,
  entry,
  samplejson,
  ischeckbox,
  increasenumber,
  decreasenumber,
  handleArr,
  arr,
}) {
  const classes = useStyles();
  const [boxes, setBoxes] = React.useState(0);
  const [open, setOpen] = React.useState(true);
  const [map, setMap] = React.useState(false);
  const [hiding, setHiding] = React.useState(false);
  // const [filter, setFilter] = React.useState("");
  // const [first, setFirst] = React.useState(isfirst);
  let isone = true;
  const handleClick = () => {
    setOpen(!open);
  };

  const func = () => {
    setHiding(!hiding);
  };
  const func2 = () => {
    setMap(!map);
  };

  return (
    <>
      {data && !isfirst
        ? Object.keys(data).map((v, i) => {
            return data[v] != null && typeof data[v] === "object" ? (
              v.toLowerCase().indexOf(filter.toLowerCase()) > -1 ? (
                isone ? (
                  <>
                    {(isone = false)}
                    <ListItem
                      key={Math.random() * 10}
                      button
                      onClick={handleClick}
                      classes={{ root: classes.listItem }}
                    >
                      <ListItemIcon
                        key={Math.random() * 10}
                        classes={{ root: classes.listIcon }}
                      >
                        {open ? <ExpandMore /> : <ChevronRight />}
                      </ListItemIcon>
                      <ListItemText key={Math.random() * 10}>
                        {parentName ? (
                          <span
                            style={{
                              font: "normal normal 600 12px/17px Open Sans",
                            }}
                          >
                            {parentName}
                          </span>
                        ) : (
                          ""
                        )}
                      </ListItemText>
                    </ListItem>
                  </>
                ) : (
                  ""
                )
              ) : (
                // data[v] != null && typeof data[v] === "object" ?
                // Object.keys(dat)
                ""
              )
            ) : (
              ""
            );
          })
        : ""}

      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        style={{ paddingLeft: "15px" }}
      >
        <List key={Math.random() * 10} component="div" style={{ padding: 0 }}>
          {data &&
            Object.keys(data).map((k, i) => {
              // if (!first) setFirst(true);
              // console.log("data k", k);
              return data[k] != null && typeof data[k] === "object" ? (
                <>
                  <Tree
                    increasenumber={increasenumber}
                    decreasenumber={decreasenumber}
                    handleArr={handleArr}
                    key={Math.random()}
                    entry={data}
                    samplejson={samplejson}
                    data={data[k]}
                    parentName={Array.isArray(data) ? "" : k}
                    // totalparent={totalparent + k + "."}
                    totalparent={totalparent + `${k}` + "."}
                    length={Object.keys(data[k]).length}
                    isfirst={false}
                    filter={filter}
                    ischeckbox={ischeckbox}
                    arr={arr}
                  />
                </>
              ) : (
                <>
                  {/* outer most div */}
                  <ListItem
                    key={Math.random() * 10}
                    button
                    className={classes.nested}
                  >
                    {!Array.isArray(data) ? (
                      // <ListItemText
                      //   key={Math.random() * 10}
                      //   classes={{ root: classes.listItemText }}
                      // >
                      <ListItem
                        className="hoverclass"
                        style={{
                          flex: "0 1 auto",
                          marginRight: "7px",
                          listStyleType: "none",
                          margin: 0,
                          paddingTop: 0,
                          paddingBottom: 0,
                          // border: "2px solid red",
                        }}
                      >
                        {k == "label" &&
                        data[k].toLowerCase().indexOf(filter.toLowerCase()) >
                          -1 ? (
                          <>
                            {/* {console.log("k", entry)} */}
                            <Item
                              increasenumber={increasenumber}
                              decreasenumber={decreasenumber}
                              handleArr={handleArr}
                              entry={entry}
                              random={k}
                              samplejson={samplejson}
                              dt={data}
                              parentname={parentName}
                              totalparent={totalparent}
                              ischeckbox={ischeckbox}
                              boxes={boxes}
                              arr={arr}
                            ></Item>
                          </>
                        ) : (
                          <div
                            className="noneid"
                            style={{ visibility: "hiding", maxHeight: "0px" }}
                          ></div>
                        )}
                      </ListItem>
                    ) : (
                      // </ListItemText>
                      <div
                        className="noneid"
                        style={{ visibility: "hiding", maxHeight: "0px" }}
                      ></div>
                    )}
                  </ListItem>
                </>
              );
            })}
        </List>
      </Collapse>
    </>
  );
}
